export const iconFontAwesomeReligionBookTanakh = (
	<i className="fa-solid fa-book-tanakh"></i>
);
